<ng-container *transloco="let t">
    <ng-container *ngIf="league?.id">
        <div class="admin-card">
            <div class="mb-2">
            <app-status-bar>
                <app-status-item iconType="warning" iconClass="bi bi-file-earmark-text">
                    <span class="label">{{ t('league.standings.viewMode.draft') }}</span>
                    <span class="value">{{ t('league.standings.included') }}
                        @if (draftIncluded.length > 0) {
                        {{ draftIncluded.join(', ') }}
                        } @else {
                        -
                        }
                    </span>
                    <span class="sub">
                        {{ t('league.roundResults.status.lastApplied') }}
                        {{ currentStandingsDraftMeta?.calculatedAt | localizedDate:'short' }}
                     </span>
                </app-status-item>

                <app-status-item iconType="info" iconClass="bi bi-globe">
                    <span class="label">{{ t('league.standings.viewMode.public') }}</span>
                    <span class="value">{{ t('league.standings.included') }}
                        @if (publicIncluded.length > 0) {
                        {{ publicIncluded.join(', ') }}
                        } @else {
                        -
                        }
                    </span>
                    <span class="sub">
                        {{ t('league.roundResults.status.lastApplied') }}
                        {{ currentStandingsPublicMeta?.appliedAt | localizedDate:'short' }}
                    </span>
                </app-status-item>
            </app-status-bar>
            </div>
            <div class="pb-2 pt-2">
                <app-toggle
                        className="me-2"
                        [options]="standingsViewOptions"
                        [activeValue]="activeViewMode"
                        (valueChange)="setActiveViewMode($event)"/>
            </div>
            <div class="pt-4">
                @if (activeViewMode === LeagueStandingsViewMode.DRAFT) {
                <app-league-results-table
                      (onRaceTypeChange)="changeRaceType($event)"
                      [availableRaceTypes]="availableRaceTypesDraft"
                      [leagueId]="league!.id!" [isAdmin]="true"
                      [viewMode]="LeagueStandingsViewMode.DRAFT"
                      [standingsMeta]="currentStandingsDraftMeta"
                      [categoryItems]="categoryItems"
                      [countries]="competitorsCountries"
                />
                }
                @if (activeViewMode === LeagueStandingsViewMode.PUBLIC) {
                <app-league-results-table
                        (onRaceTypeChange)="changeRaceType($event)"
                        [availableRaceTypes]="availableRaceTypesPublic"
                        [standingsMeta]="currentStandingsPublicMeta"
                        [leagueId]="league!.id!" [isAdmin]="true"
                        [viewMode]="LeagueStandingsViewMode.PUBLIC"
                        [categoryItems]="categoryItems"
                        [countries]="competitorsCountries"
                />
                }
            </div>
        </div>
    </ng-container>
</ng-container>